/**
 *
 * DateRangePicker
 *
 */
import * as React from 'react';
import { ResponsiveDatePicker } from '../ResponsiveDatePicker';
import { Grid } from '@mui/material';

interface Props {
  values: [from: Date | null, to: Date | null];
  onChange: Function;
}

export function DateRangePicker(props: Props) {
  const [values, setValues] = React.useState<
    [from: Date | null, to: Date | null]
  >(props.values);

  const changeFromDate = value => {
    setValues([value, values[1]]);
  };

  const changeToDate = value => {
    setValues([values[0], value]);
  };

  // Keep a ref to the latest onChange. The parent passes an inline callback
  // (new identity each render), so depending on it directly would refire the
  // notify effect on every parent render. The ref lets the effect depend
  // honestly on just `values` while always calling the current onChange.
  const onChangeRef = React.useRef(props.onChange);
  React.useEffect(() => {
    onChangeRef.current = props.onChange;
  });

  React.useEffect(() => {
    onChangeRef.current(values);
  }, [values]);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <ResponsiveDatePicker
            label={'From'}
            defaultValue={props.values[0] || undefined}
            onChange={changeFromDate}
            dateProps={{ maxDate: values[1] || undefined }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ResponsiveDatePicker
            label={'To'}
            defaultValue={props.values[1] || undefined}
            onChange={changeToDate}
            dateProps={{ minDate: values[0] || undefined }}
          />
        </Grid>
      </Grid>
    </div>
  );
}
